import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import get from '../helpers/get';
import { getSliceItems } from './content';

// eslint-disable-next-line import/prefer-default-export -- because we re-export from ./index.js
export const getOurBrandsTiles = createPerSliceIdSelector(
  getSliceItems,
  items => items.map(card => ({
    clickthrough: card.clickthrough,
    image: card.image_hover,
    video: card.looping_hover_video,
    logoVideo: card.looping_logo_video,
    logo: card.image_logo,
    title: get(card, ['title', 'text']),
  })),
);
